import { C } from '@angular/cdk/keycodes';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Question, Questionaire } from 'src/app/core/models/questionaire';
import { User } from 'src/app/core/models/user';
import { UserQuestionaire } from 'src/app/core/models/user.questionaire';
import { AuthService } from 'src/app/core/services/auth.service';
import { InterestsService } from 'src/app/core/services/interests.service';
import { QuestionaireService } from 'src/app/core/services/questionaire.service';
import { UserService } from 'src/app/core/services/user.service';
@Component({
  selector: 'app-questionaire-modal',
  templateUrl: './questionaire-modal.component.html',
  styleUrls: ['./questionaire-modal.component.scss']
})
export class QuestionaireModalComponent implements OnInit {
  user: User;
  questionare: Questionaire;
  currentQuestionNum: number = 1;
  totalQuestions: number;
  currentQuestion: Question;
  userResponses: any[] = [];
  currentResponse: Response;
  interests: Array<any>;
  allInterestsSelected: boolean[] = [];

  constructor(private questionaireService: QuestionaireService, private userService: UserService, @Inject(MAT_DIALOG_DATA) public data: any, public authService: AuthService, private interestsService: InterestsService, private parentDilogRef: MatDialogRef<QuestionaireModalComponent>) { }

  async ngOnInit(): Promise<void> {
    this.interests = [];
    this.authService.currentUser.subscribe(async data => {
      if (data !== undefined && data !== null) {
        this.user = data;
      }
    });

    let type = 'general'
    if (this.data.type == 'instructor') {
      type = 'instructor-eligibility';
    }
    this.getQuestionaire(type);
  }

  getQuestionaire(type: string) {
    this.questionaireService.getQuestionaireByType(type).subscribe(data => {
      if (data.length > 0) {
        this.questionare = data[0];
      }
      console.log(this.questionare)
      this.totalQuestions = this.questionare.questions.length;
      this.currentQuestion = this.questionare.questions[0];
      this.userResponses.fill(false, 0, this.questionare.questions.length);

      this.interestsService.getInterests().subscribe(interestsList => {
        interestsList.forEach(interest => {
          const focuses = [];
          for (var i = 0; i < interest.focuses.length; i++) {
            focuses.push({ focus: interest.focuses[i], selected: false });
          }
          this.allInterestsSelected.push(false);
          this.interests.push({ id: interest.id, interest: interest.interest, focuses: focuses, selected: false });
        });
      });

    });
  }

  setAnswer(response: any, question: Question, idx: number, isMultiSelect: boolean) {
    if (isMultiSelect) {
      if (this.userResponses[this.currentQuestionNum - 1]?.length > 0) {
        let found = this.userResponses[this.currentQuestionNum - 1].find(ele => ele.num == response.num);
        if (!found) {
          this.userResponses[this.currentQuestionNum - 1].push(response);
        } else {
          this.userResponses[this.currentQuestionNum - 1] = this.userResponses[this.currentQuestionNum - 1].filter(ele => ele.num != response.num);
        }
      } else {
        this.userResponses[this.currentQuestionNum - 1] = [];
        this.userResponses[this.currentQuestionNum - 1].push(response);
      }
    } else {
      if (this.userResponses[this.currentQuestionNum - 1]?.length > 0) {
        this.userResponses[this.currentQuestionNum - 1][this.currentQuestionNum - 1] = response;
      } else {
        this.userResponses[this.currentQuestionNum - 1] = [];
        this.userResponses[this.currentQuestionNum - 1].push(response);
      }
    }
    this.currentResponse = response;
  }

  responseSelected(num: any, idx: number) {
    let found = this.userResponses[this.currentQuestionNum - 1]?.find(ele => ele.num == num);
    if (found) {
      return true;
    } else {
      return false;
    }
  }

  updateAllComplete(i: number) {
    this.allInterestsSelected[i] = this.interests[i].focuses != null && this.interests[i].focuses.every(t => t.selected);
  }

  someComplete(i: number): boolean {
    if (this.interests[i].focuses == null) {
      return false;
    }
    return this.interests[i].focuses.filter(t => t.selected).length > 0 && !this.allInterestsSelected[i];
  }

  setAll(i, completed: boolean) {
    this.allInterestsSelected[i] = completed;
    if (this.interests[i].focuses == null) {
      return;
    }
    this.interests[i].focuses.forEach(t => (t.selected = completed));
  }

  moveBack() {
    this.currentQuestionNum -= 1;
    this.currentQuestion = this.questionare.questions[this.currentQuestionNum - 1];
  }

  moveForward() {
    if ((this.currentQuestionNum + 1) <= this.totalQuestions) {
      this.currentResponse = undefined;
      this.currentQuestionNum += 1;
      this.currentQuestion = this.questionare.questions[this.currentQuestionNum - 1];
    }
  }

  getInterests() {
    const userInterests = [];
    for (var i = 0; i < this.interests.length; i++) {
      const interest = this.interests[i];
      const foci = [];
      interest.focuses.forEach(focus => {
        if (focus.selected) {
          foci.push(focus.focus);
        }
      });
      if (foci.length > 0 || interest.selected) {
        userInterests.push({ id: interest.id, interest: interest.interest, focuses: foci });
      }
    }
    return userInterests;
  }

  async complete() {
    const userQ = new UserQuestionaire();
    userQ.questionaireDocId = this.questionare.docId;
    userQ.responses = this.userResponses;
    let flatIdx = 0;
    if (this.user.questionaireResponses?.length > 0) {
      this.user.questionaireResponses.push(JSON.parse(JSON.stringify(userQ.responses)));
      flatIdx = this.user.questionaireResponses.length - 1;

    } else {
      this.user.questionaireResponses = [];
      this.user.questionaireResponses.push(JSON.parse(JSON.stringify(userQ)));
    }
    for (var i = 0; i < this.user.questionaireResponses.length; i++) {
      //if (this.user.questionaireResponses[i].responses?.length > 0 && Array.isArray(this.user.questionaireResponses[i].responses[0])) {
      this.user.questionaireResponses[i].responses = this.user.questionaireResponses[i].responses.flat(Infinity);
      //}
    }
    this.user.playerQuestionaireComplete = true;
    this.user.interests = this.getInterests();
    await this.userService.updateUser(this.user);
    this.parentDilogRef.close();
  }

  dropDownVal(event:any, currentQuestion:Question) {
    console.log(event, ' q ', currentQuestion)
    this.setAnswer(event, currentQuestion, this.currentQuestionNum, false);
  }

  radioVal(event:any, currentQuestion:Question) {

  }
}


